import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import gearDropIcon from '../../../../asset/geardropmarker.svg'

const buildGearDropContent = () => {
  const img = document.createElement('img')
  img.src = gearDropIcon
  img.style.width = '36px'
  img.style.height = '36px'
  return img
}

const RenderGearDropMarkers = ({ gearDrop, mapReference }) => {
  const markerRefs = useRef({})

  useEffect(() => {
    if (!mapReference || !gearDrop.show) return

    const addMarkers = async () => {
      const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker')

      // Clear any existing gear drop markers
      Object.values(markerRefs.current).forEach(m => { m.map = null })
      markerRefs.current = {}

      gearDrop.markers.forEach(item => {
        const lat = item.latitude ?? item.lat
        const lng = item.longitude ?? item.lng
        if (lat == null || lng == null) return

        const mapObj = new AdvancedMarkerElement({
          content: buildGearDropContent(),
          position: { lat, lng },
          title: item.name || 'Gear Drop',
        })
        mapObj.map = mapReference
        markerRefs.current[item.id] = mapObj
      })
    }

    addMarkers()

    // Cleanup when hidden or unmounted
    return () => {
      Object.values(markerRefs.current).forEach(m => { m.map = null })
      markerRefs.current = {}
    }
  }, [gearDrop.show, gearDrop.markers, mapReference])

  return null
}

const mapStateToProps = state => ({
  gearDrop: state.gearDrop,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
})

export default connect(mapStateToProps)(RenderGearDropMarkers)
